import React, { useState, useEffect } from 'react';
import { Container, Card, CardBody,Button, Row, Col } from 'reactstrap';
import { cloneDeep, isEmpty } from 'lodash';
import ErrorBoundary from '../../components/ErrorBoundary';
import useAxios from '../../hooks/useAxios';
import { onExport, getUpdatedFilter } from '../../utils/helper';
import useContextService from '../../hooks/useContextService';
import { AppContext } from '../../context';
import SearchContainerNetwork from './SearchContainerNetwork';
import GoogleMapCard from './MapContainer';
import PharmacyList from './PharmacyDetails';
import Footer from '../../containers/Footer';
import Loader from '../../components/Loader';


let reData = {};
const initialFilterBySearch = {

};

let initialFilters = {
  currentPage: 1,
  pageSize: 10,
  orderBy: 'modifiedDate',
  order: 'desc',
  filters: [],
};
const defaultCenter = {
  lat:0,
  lng:0
};


const NetworkWbSite = () => {
  const API = useAxios();
  const {
    states: { networkwebsite },
    setStates,
  } = useContextService(AppContext);
  const { search, searchTerms } = networkwebsite;
  const [state, updateState] = useState({
    initialValues: {},
    data: [],
    records: 0,
    reset: false,
  });

  

const [Selectedradio, SetSelectedRadio] = useState("currentLocation");
  const [currentLocation, setCurrentLocation] = useState(defaultCenter);
  const[zoom,setZoom]=useState(2);
  const[islocdenied,setIslocdenied]=useState('N');
  const[boundingBox,SetBoundingBox]=useState([]); 
  const[states,setState]=useState([]);  
  const[data,setData]=useState([]);
  let stateoptions = [];
  let zipcodeoptions=[];
  const [pharmacies,setPharmacies]=useState([]);
  const[loading,setLoading]=useState(false);
  const[currentcoord,setCurrentCoord]=useState([]);



  const selectedLocation = (value) => {
    onReset();
    SetSelectedRadio(value);
    setPharmacies([]);
    initMap(value);
  };

const currentLocationPharmacy=(value)=>{
 search.maxLatitude=value.northEast.lat;
  search.minLatitude=value.southWest.lat;
   search.maxLongitude=value.northEast.lng;
  search.minLongitude=value.southWest.lng;
    search.StateCode = "";
     search.City="";
    search.ZipCode="";
    search.pharmacyName=""

   fetchnetworkdata(search);
setCurrentCoord(value);
}

useEffect(() => {
  initMap("currentLocation");
        fetchStates();
        // setLoading(false)
}, []);

const onReset=()=>{
 if (mapInstance) {
    mapInstance.setCenter(defaultCenter);
    const streetView = mapInstance.getStreetView();
    if (streetView) {
      streetView.setVisible(false);
    }
  }
setPharmacies([]);
setCurrentLocation(defaultCenter);
}

  // const initMap = (selected) => {
  //   if (selected === "currentLocation") {
  //     setIslocdenied('N');
  //     if (navigator.geolocation) {
  //       setZoom(12);
  //       navigator.geolocation.getCurrentPosition(
  //         (position) => {
  //           setCurrentLocation({
  //             lat: position.coords.latitude,
  //             lng: position.coords.longitude
  //           });
  //         },  
  //         () => {
  //           setCurrentLocation(defaultCenter);
  //           setIslocdenied('Y');
  //             SetSelectedRadio('ZIP');
  //         }
  //       );
  //     } else {
  //       setCurrentLocation(defaultCenter);
  //   // setIslocdenied('Y');
  //     }
  //   } else {
  //     setCurrentLocation(defaultCenter);
  //  setIslocdenied('Y');
  //   }
  // };

// const initMap = (selected) => {
//   if (selected === "currentLocation") {
//     if (navigator.geolocation) {
//       setZoom(12);
//       navigator.geolocation.getCurrentPosition(
//         (position) => {
//           setCurrentLocation({
//             lat: position.coords.latitude,
//             lng: position.coords.longitude
//           });
//           setIslocdenied("N");
//         },
//         () => {
//           setCurrentLocation(defaultCenter);
//           setIslocdenied("Y");
//           SetSelectedRadio("zip"); 
//         }
//       );
//     } else {
//       setCurrentLocation(defaultCenter);
//       setIslocdenied("Y");
//       SetSelectedRadio("zip");
//     }
//   } else {
//     setCurrentLocation(defaultCenter);
  
//   }
// };

 const [mapInstance, setMapInstance] = useState(null);
 

  const initMap = (selected) => {
    if (selected === "currentLocation" && navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const location = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          };
          setCurrentLocation(location);
          setZoom(10);
     },
        () => {
          if(pharmacies==[]){
          setCurrentLocation(defaultCenter);
          }
          setZoom(10);
            navigator.geolocation.getCurrentPosition(handleAllow, handleDeny);
        }
      );
    } else {
      setCurrentLocation(defaultCenter);
      setZoom(10);
    }
  };
async function handleDeny() {
setIslocdenied("Y");
    // setSelectedValue('ZIP');
    SetSelectedRadio('ZIP');
  }
  async function handleAllow() {
  setIslocdenied("N");
    //  setSelectedValue('CurrentLocation');
     SetSelectedRadio('CurrentLocation');
  }

  const onSearch=(values)=>{
  search.StateCode=values.state;
  search.PharmacyName=values.pharmacyName;
  search.ZipCode=values.ZipCode; 
  search.City=values.City;
  search.maxLatitude=null;
  search.minLatitude=null;
   search.maxLongitude=null;
  search.minLongitude=null;
  onReset();
 fetchnetworkdata(search);
  }

   const fetchnetworkdata = async (filters) => {
    
   setLoading(true);
    try {
    
      const {data} = await API.post(`/PlanNetwork/getPlanNetworkDetails`, filters
      );
      if(data){
        setPharmacies(data.items?data.items:[]);
      setLoading(false);
      }
      else{
       
      setLoading(false);
      }
  
    } catch (error) {
      setLoading(false);
    }
  };
 
   const fetchStates = async () => {
        // setLoading(true)
        try {
            const { data } = await API.get(
                `/PlanNetwork/getStates`
            );
            if (Array.isArray(data) && data.length > 0) {
  const stateOptions = Array.from(
    new Map(
      data.map((item) => [
        item.stateCode,
        { id: item.stateCode, label: item.state },
      ])
    ).values()
  );

  setState(stateOptions);
} else {
  setState([]);
}
            // setLoading(false)

        } catch (error) {

        }
    }

    //   const fetchZipCodes = async (countyName) => {
    //     setLoading(true)
    //     try {
    //         const { data } = await API.post(
    //             `/PlanNetwork/getZipCodes/${selectedState}/${countyName}`
    //         );
    //         if (data) {

    //             for (var x in data) {
    //                 zipcodeoptions.push({ "id": data[x].physicalLocationZipCode, "label": data[x].physicalLocationZipCode })
    //             }
    //             setZipCode(zipcodeoptions)
    //         }
    //         setLoading(false)
    //     } catch (error) {

    //     }
    // }



  return (
    
    <div>
       {loading && <Loader opacity={0.01} color="black" />}
      <Container  fluid className='my-3 ' >
        <Card className='border-0 shadow-top'>
          <CardBody className='section-devider-border'>
            <ErrorBoundary>
             
              <SearchContainerNetwork 
             selectedlocation={selectedLocation}
            selectedRadio={Selectedradio}
            islocdenied={islocdenied}
            onReset={onReset}
            states={states}
            onSearch={onSearch}
              />

            </ErrorBoundary>
              </CardBody>
         
          {/* <CardBody className='pt-0' > */}
            <Row md={2}>
              <Col>
            <ErrorBoundary>
             <PharmacyList
             pharmacies={pharmacies}/>
                         </ErrorBoundary>
                         </Col>
                    <Col>
                       <ErrorBoundary>
               <GoogleMapCard 
                  currentLocation={currentLocation}
                   zoom={zoom}
                      setMapInstance={setMapInstance}
        setBoundingBox={SetBoundingBox}
         mapInstance={mapInstance}
            pharmacies={pharmacies}
            Selectedradio={Selectedradio}
            currentLocationPharmacy={currentLocationPharmacy}
 />
               </ErrorBoundary>
               </Col>
                         </Row>
                        

        </Card>
      
      </Container>




    </div>
    
  );
};

export default NetworkWbSite;